import getNested from 'lodash-es/get';
import { formatVolume } from '@/shared/number-utils';
import moment from 'moment';


function getVesselData(vessel) {
  return {
    imo: getNested(vessel, 'imo', '--'),
    vesselName: getNested(vessel, 'static.name', '--'),
    dwt: formatVolume(getNested(vessel, 'vesselMasterdata.dwt', '--'), '1m'),
    segment: getNested(vessel, 'vesselMasterdata.segment', '--'),
    ladenStatus: getNested(vessel, 'state.ladenStatus', '--'),
    destination: getDestination(vessel),
    draught: getNested(vessel, 'static.draught'),
    ladenPercent: getLadenPercent(vessel),
    speed: getNested(vessel, 'position.speed', '--') || '--',
    lastUpdate: formatDate(getNested(vessel, 'position.timestamp', '2001-01-01')),
    eta: formatDate(getNested(vessel, 'static.eta', '2001-01-01')),
  };
}

function getFormattedVesselData(vessel) {
  const vesselData = getVesselData(vessel);
  return {
    'IMO': vesselData.imo,
    'Vessel name': vesselData.vesselName,
    'DWT': vesselData.dwt,
    'Segment': vesselData.segment,
    'Laden status': vesselData.ladenStatus,
    'Destination': vesselData.destination,
    'Draught': vesselData.draught,
    '% of max draught': vesselData.ladenPercent,
    'Speed': vesselData.speed,
    'Last update': vesselData.lastUpdate,
    'ETA': vesselData.eta,
  };
}

function formatDate(dateString) {
  if(dateString) {
    return moment(dateString).format('YYYY-MM-DD HH:mm:ss');
  } else {
    return '--';
  }
}

function getDestination(vessel) {
  const portName  = getNested(vessel, 'state.destination.portName', null);
  const countryCode  = getNested(vessel, 'state.destination.country', null);
  const unlocode  = getNested(vessel, 'state.destination.unlocode', null);

  if(portName && unlocode) {
    return `${portName} (${unlocode})`;
  }

  if(portName && countryCode) {
    return `${portName} (${countryCode})`;
  }

  const rawDestination = getNested(vessel, 'state.destination.rawDestination', null);
  if(rawDestination) {
    return rawDestination
  }

  return getNested(vessel, 'static.destination', '--');
}

function getLadenPercent(vessel) {
  let ladenPercent = getNested(vessel, 'state.ladenPercent', null);
  if(ladenPercent) {
    return (ladenPercent * 100).toFixed(2) + '%';
  }

  const draught = getNested(vessel, 'static.draught', null);
  const maxDraught = getNested(vessel, 'vesselMasterdata.maxDraught', null);
  if(draught && maxDraught) {
    return ((draught/maxDraught) * 100).toFixed(2) + '%';
  }

  return '--';
}


export {
  getVesselData,
  getFormattedVesselData,
}
